export { AtnDsButtonComponent as Component } from './button.component'
